import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { APP_URLS } from '../../../consts';
import PrizesIcon from './../../../assets/Itv/Prizes-White.svg';
import PrizesIconActive from './../../../assets/Itv/Prizes-Colour.svg';
import BingoIcon from './../../../assets/Itv/Bingo-White.svg';
import BingoIconActive from './../../../assets/Itv/Bingo-Colour.svg';
import SpinsIcon from './../../../assets/Itv/Spins-White.svg';
import SpinsIconActive from './../../../assets/Itv/Spins-Colour.svg';
import { useUserContext } from '../../../providers/UserProvider';
import { joinStrings } from '../../../utils/string';
import { TabsItem } from './types';
import { BRANDS } from '../types';
import { GetSubNavigationQuery } from '../../../libs/graphql/betzoneDirectusAPI/queries/__generated__/get-sub-nav.query.generated';
import './ItvTabsNav.scss';

export const ItvTabsNav: FC<{ subNavigation: GetSubNavigationQuery }> = ({ subNavigation }) => {
  const { theme } = useUserContext();

  const [firstBingoItemData] = subNavigation.bingo;
  const [firstSpinItemData] = subNavigation.spins;

  const [firstSpinItem] = firstSpinItemData.translations ?? [];
  const [firstBingoItem] = firstBingoItemData.translations ?? [];

  const tabs: TabsItem[] = [
    {
      key: BRANDS.PRIZES,
      pathTo: `${APP_URLS.itv.prizes}/bingo`,
      icons: {
        defaultIcon: PrizesIcon,
        [BRANDS.PRIZES]: PrizesIconActive,
      },
    },
    {
      key: BRANDS.BINGO,
      pathTo: `${APP_URLS.itv.bingo}/${firstBingoItem?.slug}`,
      icons: {
        defaultIcon: BingoIcon,
        [BRANDS.BINGO]: BingoIconActive,
      },
    },
    {
      key: BRANDS.SPINS,
      pathTo: `${APP_URLS.itv.spins}/${firstSpinItem?.slug}`,
      icons: {
        defaultIcon: SpinsIcon,
        [BRANDS.SPINS]: SpinsIconActive,
      },
    },
  ];

  return (
    <nav className="tabs">
      <ul className="tabs__list">
        {tabs.map((tab) => {
          return (
            <li key={tab.key} className="tabs__item">
              <NavLink
                to={tab.pathTo}
                end
                className={(): string => joinStrings(['tabs__link', theme === tab.key && 'tabs__link--active'])}
              >
                <img src={tab.icons[theme] || tab.icons.defaultIcon} alt={tab.key} className="tabs__icon" />
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
